
/* eslint-disable no-trailing-spaces */
import { createMuiTheme } from '@material-ui/core/styles';
/**
 *
 * All styling and theme related changes should be taken from this object
 * @param - palette,typography,imageAlbum
 *@author - Ashok Reddy
 */

export const colorPalatte = {
  primary: '#4682CE',
  primary900: '#183F69',
  primary700: '#245793',
  primary400: '#72A7E1',
  primary300: '#C5DAF2',
  primary200: "#E3ECF8",
  secondary: '#d3d3d3',
  error: '#FC0303',
  error200: '#ffcccb',
  textSecondary: 'E7F9E5',
  customColor1: '#F1A14D',//for + icon background
  orange600: "#d17902",
  orange200: "#fcebd4",//for total periods in rules
  grey: '#D9D9D9',
  grey900: '#404040',
  grey700: '#6B6B6B',
  grey600: '#969696',
  grey400: '#D9D9D9',
  grey300: '#ECECEC',
  grey200: '#F7F7F7',
  green:"#1B5E20",
  green200:"#C8E6C9",
};


const imageAlbum = {
  logo: require('../images/logo.png'),
  toolbarLogo: require('../images/toolbarLogo.png'),
  excelIcon: require('../images/excel.png'),
  timeTableIcon: require('../images/timetable.png'),
  timeTableBlueIcon: require('../images/calendar.png'),
  applyChanges: require('../images/rulesIcons/ApplyChanges.png'),
  applyChangesInactive: require('../images/rulesIcons/ApplyChangesInactive.png'),

  createTimetable: require('../images/rulesIcons/CreateTimetable.png'),
  createTimetableInactive: require('../images/rulesIcons/CreateTimetableInactive.png'),

  errorOnlyIcon: require('../images/rulesIcons/ErrorOnly.png'),
  errorsAndWarningsIcon: require('../images/rulesIcons/ErrorsAndWarnings.png'),
  noErrorOrWarningIcon: require('../images/rulesIcons/NoErrorOrWarning.png'),
  warningsOnlyIcon: require('../images/rulesIcons/WarningsOnly.png'),

  precheck: require('../images/rulesIcons/Precheck.png'),
  precheckInactive: require('../images/rulesIcons/PrecheckInactive.png'),

  showAssignedRooms: require('../images/rulesIcons/ShowAssignedRooms.png'),
  showAssignedTeachers: require('../images/rulesIcons/ShowAssignedTeachers.png'),
  showPeriod: require('../images/rulesIcons/ShowPeriod.png'),
  showPeriodPreferences: require('../images/rulesIcons/ShowPeriodPreferences.png'),
  showRoom: require('../images/rulesIcons/ShowRoom.png'),
  showTeacher: require('../images/rulesIcons/ShowTeacher.png'),
  readyForPrecheck: require('../images/rulesIcons/ReadyForPrecheck.png'),



  
};




const actionButton = {
  color: colorPalatte.primary,
  textTransform: 'none'


}

const rulesActiveIconsStyle = { width: '30px', cursor: 'pointer' }
const rulesIconsDimensionStyle={
  width:'30px'
}

const mainPageCardStyle = {
  textAlign: 'center',
  align: 'center',
}

const typographyTitle = {
  textAlign: 'center',
  width: '100%'
}
const typographyDescription = {
  textAlign: 'center',
  width: '100%'
}
const muiTextFieldStyleForMainScreen = {

  display: 'flex',
  flex: 1
}
const mainGridstyle = {
  padding: 16
}

const addSharedRoomGridStyle = {
  border: "1px solid " + colorPalatte.grey600
}

const gridTableStyle = {
  border: "1px solid " + colorPalatte.grey600,
  //padding: 8,
  boxSizing: 'border-box',
  height: '56px',
  background: "white",

}

const gridTableStyleForSharedRoomMasterData = {
  border: "1px solid " + colorPalatte.grey600,
  padding: 8,
  boxSizing: 'border-box',
  height: '56px',
  background: "white",
  justify: "flex-start",
  alignItems: "center"

}

const gridTableClearButtonStyle = {
  border: "1px solid " + colorPalatte.grey600,
  //padding: 8,
  boxSizing: 'border-box',
  height: '56px',
  background: colorPalatte.grey200,

}
const gridTableSelectStyle = {
  border: "1px solid " + colorPalatte.grey600,
  padding: 8,
  boxSizing: 'border-box',
  height: '56px'

}
const gridTableEditStyle = {
  borderTop: "1px solid " + colorPalatte.grey600,
  borderBottom: "1px solid " + colorPalatte.grey600,
  borderRight: "1px solid " + colorPalatte.grey600,
  //padding: 8,
  boxSizing: 'border-box',
  height: '56px'

}
const gridTableBeforeEditStyle = {
  borderTop: "1px solid " + colorPalatte.grey600,
  borderBottom: "1px solid " + colorPalatte.grey600,
  borderLeft: "1px solid " + colorPalatte.grey600,
  //padding: 8,
  boxSizing: 'border-box',
  height: '56px'

}

const gridTableStyleForRule = {
  border: "2px solid " + colorPalatte.grey,
  //marginRight: "5px",
  height: "auto",
  // flexBasis: "12%"
}
const gridTableShowRadio = {
  border: "2px solid " + colorPalatte.grey,
  //marginRight: "5px",
  //height: "30px"
}
const noLeftAndTopBorder = {
  borderTop: "None",
  borderLeft: "None"
}
const showRulesRadion = {

  height: "28px"

}

const gridTableStyleForShowRule = {

  marginRight: "10px",
  marginLeft: "20px"

}
const gridActionContainerStyle = {
  background: colorPalatte.grey200,
  cursor: 'pointer', border: '1px solid ' + colorPalatte.grey600,
  padding: 8,
  boxSizing: 'border-box',
}
const gridActionContainerStyleForStickyButton = {
  position: 'sticky',
  bottom: '0px',
  border: '1px solid ' + colorPalatte.grey600,
  background: colorPalatte.grey200,
  cursor: 'pointer',
  padding: 8,
  boxSizing: 'border-box',
}
const colorCatalogue =
  ["#A2AC96", "#E3EADB", "#D688DF", "#B69FA2", "#FF806C", "#F87DAC", "#FCCEC7", "#57D885", "#9C9BC4", "#8EA7C4",
    "#F79BD4", "#C78E60", "#FDD8B6", "#96C3F3", "#E0DFFA", "#B1B1F3", "#78ADB7", "#FED700", "#E1ECFB", "#CAB533",
    "#FEF4B3", "#F4E9EA", "#E8F9D6", "#FCB06D", "#D6F0F4", "#CB7F73", "#CDF4DA", "#67B582", "#F2DBF5", "#B282B8",
    "#9EBF79", "#DCB5BB", "#C99D74", "#E8D2BF", "#F5CEDB", "#BBCAA7", "#B4EA76", "#AA886C", "#72CDDD"]
const gridHeaderTextStyle = {
  color: colorPalatte.primary

}
const tableHeaderTextStyle = {
  textAlign: "center",
  font: "Bold 14px/13px Arial",
  letterSpacing: "0",
  color: colorPalatte.grey700,
  padding: 16,
  boxSizing: 'border-box',

}
const tableHeaderStyle = {
  background: colorPalatte.primary200,
  border: "1px solid " + colorPalatte.grey600
}
const tableHeaderStyle1 = {
  background: colorPalatte.primary200,
  border: "1px solid " + colorPalatte.grey600,
   outline: "1px solid " + colorPalatte.grey600
}
const gridHeaderStyle = {
  background: colorPalatte.primary200,
  height: "6vh",

}
const gridHeaderStyleForRow = {
  background: "#F6FAFF",
  borderBottom: "1px solid " + colorPalatte.primary
}
const launchPage = {
  flexGrow: '1',
  background: '#43cea2',  /* fallback for old browsers */
  // eslint-disable-next-line no-dupe-keys
  background: '-webkit-linear-gradient(to left, #185a9d, #43cea2)',  /* Chrome 10-25, Safari 5.1-6 */
  // eslint-disable-next-line no-dupe-keys
  background: 'linear-gradient(to left, #185a9d, #43cea2)' /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  , width: '100%',
}

const pointer = {
  cursor: "pointer",
}


const borderForGrid = {

  borderBottom: "1px solid " + colorPalatte.primary,
  borderLeft: "1px solid " + colorPalatte.primary,
  borderRight: "1px solid " + colorPalatte.primary,
  padding: "4px"

}
const linkStyle = {
  color: 'black', cursor: 'pointer', textDecoration: 'none'
}


const spinnerImgStyle = {
  textDecoration: "none",
  position: 'absolute',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: '80px', width: '80px',
  margin: 'auto',
}
const spinnerImgStyleForButton = {
  textDecoration: "none",
  height: '30px', width: '30px',
  margin: 'auto',
}
const spinnerImgStyleForCell= {
  textDecoration: "none",
  height: '15px', width: '15px',
  paddingTop:'3px'
}



const loginTitleStyle = {
  textAlign: 'center',
  color: colorPalatte.primary,
  fontWeight: 'bold'
}
const numberWithNoArrowButtons = {
  "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0
  }
}

const addMoreTeaacherBtnStyle = {
  background: "#F6FAFF",
  border: "1px solid " + colorPalatte.primary,
  fontWeight: 'bold'

}
const appBarTextItem = {
  font: "Bold 14px / 12px Arial",
  color: colorPalatte.primary700,
  textTransform: 'none'
}

const appLogoStyle = { height: '55px',cursor:'pointer' }
const buttonTextFont = "Bold 12px Arial"

const primaryButtonStyle = {

  background: colorPalatte.primary,
  borderRadius: "5px",
  font: buttonTextFont,
  color: '#fff',
  lineHeight: "15px",
  border: "2px solid " + colorPalatte.primary,

}
const buttonStyleForNewSchedule = {

  background: colorPalatte.primary,
  borderRadius: "5px",
  font: "Bold 16px Arial",
  color: '#fff',
  lineHeight: "20px",
  width:'200px',
  border: "2px solid " + colorPalatte.primary,

}

const primaryButtonDisabledStyle = {
  background: colorPalatte.primary300,
  borderRadius: "5px",
  font: buttonTextFont,
  color: '#fff',
  lineHeight: "15px",
  border: "2px solid " + colorPalatte.primary300,

}
const titleTextStyleForTT = { fontWeight: 600 }
const titleTextStyleForTTBlur = { filter: 'blur(2px)', fontWeight: 600 }
const cellLunchTextStyleForTT = { fontSize: 12, textAlign: 'center', fontWeight: 600 }
const cellLunchTextStyleForTTBlur = { filter: 'blur(2px)', fontSize: 12, textAlign: 'center', fontWeight: 600 }
const cellTextStyleForTT = { fontSize: 12 }
const cellTextStyleForTTBlur = { filter: 'blur(2px)', fontSize: 12 }
const dayToggleButtonForCalendarStyle = { height: "35px", maxWidth: "35px", margin: 6, }
const dayToggleButtonForPreferedPeriodsStyle = { height: "27px", width: "27px", margin: 2, }
const dayToggleButtonForAvailabilityStyle = { height: "35px", maxWidth: "35px", margin: 6, }
const secondaryButtonStyle = {

  background: "#FFFFFF",
  border: "2px solid " + colorPalatte.primary,
  borderRadius: "5px",
  color: colorPalatte.primary,
  font: buttonTextFont,
  lineHeight: "15px"
}
const createAdminButton = {

  textTransform: "none",
  background: "#FFFFFF",
  border: "2px solid " + colorPalatte.primary,
  borderRadius: "5px",
  color: colorPalatte.primary,
  font: buttonTextFont,
  lineHeight: "15px"
}
const secondaryButtonDisabledStyle = {
  background: "#FFFFFF",
  border: "2px solid " + colorPalatte.primary300,
  borderRadius: "5px",
  color: colorPalatte.primary300,
  font: buttonTextFont,
  lineHeight: "15px"
}
const radioTitleStyle = {
  textAlign: "left",
  font: "Bold 12px/14px Arial",
  letterSpacing: "0",
  color: colorPalatte.grey700,
  opacity: "1"
}
const addMoreStyle = {
  textAlign: "left",
  font: "Bold 14px/16px Arial",
  letterSpacing: "0",
  color: colorPalatte.grey700,
  opacity: "1"
}
const indicatiorColor = "primary"
const textColor = '#404040'
const theme = createMuiTheme({

  palette: {
    action: {
      disabledBackground: colorPalatte.primary300,
    },
    primary: {
      main: colorPalatte.primary,
      dark: colorPalatte.primary700,
      darker: colorPalatte.primary900,
      light: colorPalatte.primary400,
      lighter: colorPalatte.primary300,
      lightest: colorPalatte.primary200,
      contrastText: "#fff"
    },
    secondary: {
      main: colorPalatte.secondary,
      contrastText: "#fff"
    },
    textSecondary: {
      main: colorPalatte.textSecondary,
    },
    error: {
      main: colorPalatte.error,
      light: colorPalatte.error200,
    },
    green: {
      main: colorPalatte.green,
      light: colorPalatte.green200,
    },
    orange: colorPalatte.customColor1,
    orangeDark: colorPalatte.orange600,
    orangeLight:colorPalatte.orange200,
    grey: {
      main: colorPalatte.grey,
      dark: colorPalatte.grey600,
      darker: colorPalatte.grey700,
      darkest: colorPalatte.grey900,
      light: colorPalatte.grey400,
      lighter: colorPalatte.grey300,
      lightest: colorPalatte.grey200,
      contrastText: "#fff"
    },
  },
  background: {
    color: {
      main: '#f0f9ff',
      secondary: '#b8ddff'
    }
  },

  typography: {
    useNextVariants: true,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    h1: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '30px',
      color: textColor
    },
    h2: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '26px',
      color: textColor
    },
    h3: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '22px',
      color: textColor
    },
    h4: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '20px',
      color: textColor
    },
    h5: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '18px',
      color: textColor
    },
    h6: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '16px',
      color: textColor
    },
    h7: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '14px',
      color: textColor
    },
    h8: {
      fontFamily: "Arial",
      fontWeight: 600,
      fontSize: '12px',
      color: textColor
    },
    body: {
      fontFamily: "Arial",
      fontSize: '16px',
      color: textColor
    },
    body1: {
      fontFamily: "Arial",
      fontSize: '14px',
      color: textColor
    },
    span: {
      fontFamily: "Arial",
      fontSize: '12px',
      color: textColor
    },

  },
  'typographyStyles': {
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6',
    SUBTITLE1: 'subtitle1',
    SUBTITLE2: 'subtitle2',
    BODY1: 'body1',
    BODY2: 'body2',
    CAPTION: 'caption',
    BUTTON: 'button',
    OVERLINE: 'overline',
    SRONLY: 'srOnly',
    INHERIT: 'inherit',
    DISPLAY4: 'display4',
    DISPLAY3: 'display3',
    DISPLAY2: 'display2',
    DISPLAY1: 'display1',
    HEADLINE: 'headline',
    TITLE: 'title',
    SUBHEADING: 'subheading',
  },
  'overrides': {},
  'imageAlbum': imageAlbum,
  'actionButton': actionButton,
  'mainPageCardStyle': mainPageCardStyle,
  'linkStyle': linkStyle,
  'launchPage': launchPage,
  'muiTextFieldStyleForMainScreen': muiTextFieldStyleForMainScreen,
  'typographyTitle': typographyTitle,
  'typographyDescription': typographyDescription,
  'mainGridstyle': mainGridstyle,
  "colorPalatte": colorPalatte,
  "gridHeaderStyle": gridHeaderStyle,
  "gridTableStyle": gridTableStyle,
  "gridTableStyleForSharedRoomMasterData": gridTableStyleForSharedRoomMasterData,
  "gridTableStyleForRule": gridTableStyleForRule,
  "gridHeaderTextStyle": gridHeaderTextStyle,
  "gridActionContainerStyle": gridActionContainerStyle,
  "pointer": pointer,
  "borderForGrid": borderForGrid,
  "gridTableStyleForShowRule": gridTableStyleForShowRule,
  "gridTableShowRadio": gridTableShowRadio,
  "showRulesRadion": showRulesRadion,
  "noLeftAndTopBorder": noLeftAndTopBorder,
  "linkStyle": linkStyle,
  "spinnerImgStyle": spinnerImgStyle,
  "loginTitleStyle": loginTitleStyle,
  "numberWithNoArrowButtons": numberWithNoArrowButtons,
  "lightGrey": "#E8E8E8",
  "addMoreTeaacherBtnStyle": addMoreTeaacherBtnStyle,
  "gridHeaderStyleForRow": gridHeaderStyleForRow,
  "gridActionContainerStyleForStickyButton": gridActionContainerStyleForStickyButton,
  "colorCatalogue": colorCatalogue,
  "appBarTextItem": appBarTextItem,
  "appLogoStyle": appLogoStyle,
  "primaryButtonStyle": primaryButtonStyle,
  "primaryButtonDisabledStyle": primaryButtonDisabledStyle,
  "secondaryButtonStyle": secondaryButtonStyle,
  "createAdminButton": createAdminButton,
  "secondaryButtonDisabledStyle": secondaryButtonDisabledStyle,
  "radioTitleStyle": radioTitleStyle,
  "addMoreStyle": addMoreStyle,
  "tableHeaderTextStyle": tableHeaderTextStyle,
  "tableHeaderStyle": tableHeaderStyle,
  "gridTableEditStyle": gridTableEditStyle,
  "gridTableBeforeEditStyle": gridTableBeforeEditStyle,
  "gridTableSelectStyle": gridTableSelectStyle,
  "gridTableClearButtonStyle": gridTableClearButtonStyle,
  "addSharedRoomGridStyle": addSharedRoomGridStyle,
  "gridTableSelectStyle": gridTableSelectStyle,
  "titleTextStyleForTT": titleTextStyleForTT,
  "titleTextStyleForTTBlur": titleTextStyleForTTBlur,
  "cellTextStyleForTT": cellTextStyleForTT,
  "cellTextStyleForTTBlur": cellTextStyleForTTBlur,
  "cellLunchTextStyleForTT": cellLunchTextStyleForTT,
  "cellLunchTextStyleForTTBlur": cellLunchTextStyleForTTBlur,
  "dayToggleButtonForCalendarStyle": dayToggleButtonForCalendarStyle,
  "dayToggleButtonForPreferedPeriodsStyle": dayToggleButtonForPreferedPeriodsStyle,
  "dayToggleButtonForAvailabilityStyle": dayToggleButtonForAvailabilityStyle,
  "textColor": textColor,
  "tableHeaderStyle1": tableHeaderStyle1,
  "spinnerImgStyleForButton": spinnerImgStyleForButton,
  "spinnerImgStyleForCell": spinnerImgStyleForCell,
  "indicatiorColor":indicatiorColor,
  "rulesIconsDimensionStyle": rulesIconsDimensionStyle,
  "rulesActiveIconsStyle": rulesActiveIconsStyle,
  "buttonStyleForNewSchedule": buttonStyleForNewSchedule
},

);
export default theme;
// eslint-disable-next-line no-multiple-empty-lines




